import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
import { portalEvent, portalUrl } from './portalApi';
const money = cents => `${new Intl.NumberFormat('pl-PL', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(Number(cents || 0) / 100)} PLN`;
const seo = (title, description) => {
  document.title = `${title} - NovaTruck & RP`;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'description';
    document.head.appendChild(meta);
  }
  meta.content = description.slice(0, 160);
};
class PortalPage extends Page {
  data = null;
  loading = true;
  error = '';
  section = '';
  oninit(v) {
    super.oninit(v);
    this.load();
  }
  params() {
    return {};
  }
  async load() {
    this.loading = true;
    try {
      this.data = await app.request({
        method: 'GET',
        url: portalUrl(this.section, this.params())
      });
    } catch {
      this.error = 'Nie udało się pobrać danych.';
    }
    this.loading = false;
    m.redraw();
  }
  shell(title, eyebrow, content) {
    return m("div", {
      className: "NtPortalPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, eyebrow), m("h1", null, title)), this.loading ? m(LoadingIndicator, null) : this.error ? m("div", {
      className: "NtPortalEmpty"
    }, this.error) : content)));
  }
}
export class PremiumPage extends PortalPage {
  section = 'premium';
  oncreate() {
    seo('Premium', 'Pakiety Premium NovaTruck & RP i korzyści dostępne w grze.');
    window.scrollTo(0, 0);
  }
  view() {
    return this.shell('Premium', 'NOVATRUCK • WSPARCIE PROJEKTU', m("div", {
      className: "NtPremiumGrid"
    }, (this.data?.packages || []).length ? this.data.packages.map(p => m("article", null, m("span", null, icon('fas fa-gem')), m("h2", null, p.name), m("strong", null, money(p.price_cents)), m("small", null, p.duration_days, " dni"), m("p", null, p.description), m("ul", null, String(p.benefits || '').split('\n').filter(Boolean).map(x => m("li", null, icon('fas fa-check'), x))), m("button", {
      className: "Button Button--primary",
      disabled: true
    }, "Zakup wkr\xF3tce"))) : m("div", {
      className: "NtPortalEmpty"
    }, "Pakiety Premium pojawi\u0105 si\u0119 po dodaniu ich w NCC.")));
  }
}
export class PenaltiesPage extends PortalPage {
  section = 'penalties';
  query = '';
  oncreate() {
    seo('Lista kar', 'Publiczna lista kar administracyjnych i taryfikatora NovaTruck & RP.');
    window.scrollTo(0, 0);
  }
  params() {
    return {
      q: this.query
    };
  }
  view() {
    return this.shell('Lista kar', 'BEZPIECZEŃSTWO • TRANSPARENTNOŚĆ', m('[', null, m("form", {
      className: "NtPortalSearch",
      onsubmit: e => {
        e.preventDefault();
        this.load();
      }
    }, m("input", {
      className: "FormControl",
      value: this.query,
      placeholder: "Gracz albo pow\xF3d kary",
      oninput: e => this.query = e.target.value
    }), m("button", {
      className: "Button Button--primary"
    }, "Szukaj")), m("div", {
      className: "NtPenaltyList"
    }, (this.data?.penalties || []).map(p => m("article", null, m("span", {
      className: `is-${p.status}`
    }, icon(p.source === 'police' ? 'fas fa-shield-alt' : 'fas fa-gavel')), m("div", null, m("small", null, p.source === 'police' ? 'TARYFIKATOR POLICJI' : 'KARA ADMINISTRACYJNA', " \u2022 #", p.id), m("h3", null, p.username || 'Nieznany gracz', " \u2014 ", p.penalty_type), m("p", null, p.reason)), m("aside", null, m("strong", null, p.amount_cents ? money(p.amount_cents) : p.status), m("small", null, p.starts_at || p.created_at), p.evidence_url ? m("a", {
      href: p.evidence_url,
      target: "_blank",
      rel: "noopener"
    }, "Dow\xF3d") : null))))));
  }
}
export class VehiclesPage extends PortalPage {
  section = 'vehicles';
  query = '';
  source = '';
  oncreate() {
    seo('Pojazdy', 'Salony, giełda i aukcje pojazdów NovaTruck & RP.');
    window.scrollTo(0, 0);
  }
  params() {
    return {
      q: this.query,
      source: this.source
    };
  }
  view() {
    return this.shell('Pojazdy', 'SALONY • GIEŁDA • AUKCJE', m('[', null, m("form", {
      className: "NtPortalSearch NtVehicleFilters",
      onsubmit: e => {
        e.preventDefault();
        this.load();
      }
    }, m("input", {
      className: "FormControl",
      value: this.query,
      placeholder: "Szukaj modelu",
      oninput: e => this.query = e.target.value
    }), m("select", {
      className: "FormControl",
      value: this.source,
      onchange: e => {
        this.source = e.target.value;
        this.load();
      }
    }, m("option", {
      value: ""
    }, "Wszystkie \u017Ar\xF3d\u0142a"), m("option", {
      value: "salon"
    }, "Salony"), m("option", {
      value: "gielda"
    }, "Gie\u0142da"), m("option", {
      value: "aukcja"
    }, "Aukcje")), m("button", {
      className: "Button Button--primary"
    }, "Szukaj")), m("div", {
      className: "NtVehicleList"
    }, (this.data?.vehicles || []).map(v => m(Link, {
      href: `/pojazdy/${v.id}`,
      style: {
        backgroundImage: v.image_url ? `linear-gradient(90deg,rgba(8,10,12,.98),rgba(8,10,12,.72),rgba(8,10,12,.2)),url(${v.image_url})` : undefined
      }
    }, m("div", null, m("small", null, String(v.source).toUpperCase(), " \u2022 #", v.mta_vehicle_id || v.id), m("h2", null, v.model_name), m("p", null, v.owner_name ? `Właściciel: ${v.owner_name}` : `${v.salon_name || 'Salon'} • ${v.location || 'San Andreas'}`), m("span", null, icon('fas fa-road'), " ", Number(v.mileage_km || 0).toLocaleString('pl-PL'), " km"), m("span", null, icon('fas fa-car-crash'), " stan ", v.vehicle_condition, "%"), m("span", null, icon('fas fa-circle-notch'), " opony ", v.tyre_condition, "%")), m("aside", null, m("strong", null, money(v.current_bid_cents || v.price_cents)), m("small", null, v.auction_enabled ? 'Aktualna oferta' : 'Cena'), icon('fas fa-chevron-right')))))));
  }
}
export class VehiclePage extends PortalPage {
  section = 'vehicle';
  id = 0;
  amount = '';
  oninit(v) {
    this.id = Number(m.route.param('id'));
    super.oninit(v);
  }
  params() {
    return {
      id: this.id
    };
  }
  oncreate() {
    seo('Pojazd', 'Szczegółowe informacje i historia aukcji pojazdu NovaTruck & RP.');
    window.scrollTo(0, 0);
  }
  async bid() {
    if (!app.session.user) {
      this.error = 'Zaloguj się, aby wziąć udział w aukcji.';
      return;
    }
    const cents = Math.round(Number(this.amount.replace(',', '.')) * 100);
    try {
      await portalEvent({
        action: 'bid',
        listing_id: this.id,
        amount_cents: cents
      });
      this.amount = '';
      await this.load();
    } catch (e) {
      this.error = e?.response?.errors?.[0]?.detail || 'Nie udało się zapisać oferty.';
      m.redraw();
    }
  }
  view() {
    const v = this.data?.vehicle;
    if (!this.loading && !v) return this.shell('Pojazd', 'KATALOG NOVATRUCK', m("div", {
      className: "NtPortalEmpty"
    }, "Nie znaleziono pojazdu."));
    return this.shell(v?.model_name || 'Pojazd', 'KARTA POJAZDU', v ? m('[', null, m("article", {
      className: "NtVehicleDetail",
      style: {
        backgroundImage: v.image_url ? `linear-gradient(90deg,rgba(7,9,11,.96),rgba(7,9,11,.55)),url(${v.image_url})` : undefined
      }
    }, m("div", null, m("small", null, String(v.source).toUpperCase(), " \u2022 ID ", v.mta_vehicle_id || v.id), m("h1", null, v.model_name), m("p", null, v.owner_name ? `Właściciel: ${v.owner_name}` : `${v.salon_name || 'Salon'} — ${v.location || 'San Andreas'}`)), m("strong", null, money(v.current_bid_cents || v.price_cents))), m("div", {
      className: "NtVehicleFacts"
    }, m("span", null, m("b", null, Number(v.mileage_km).toLocaleString('pl-PL'), " km"), "Przebieg"), m("span", null, m("b", null, v.vehicle_condition, "%"), "Stan pojazdu"), m("span", null, m("b", null, v.tyre_condition, "%"), "Stan opon"), m("span", null, m("b", null, v.tuning || 'Seryjny'), "Modyfikacje")), v.auction_enabled ? m("section", {
      className: "NtAuction"
    }, m("h2", null, "Aukcja online"), m("p", null, "Oferta na forum jest przekazywana do systemu gie\u0142dy MTA. Fa\u0142szywe podbijanie ceny podlega karze."), m("div", null, m("input", {
      className: "FormControl",
      placeholder: "Kwota PLN",
      value: this.amount,
      oninput: e => this.amount = e.target.value
    }), m("button", {
      className: "Button Button--primary",
      onclick: () => this.bid()
    }, "Licytuj")), m("ol", null, (this.data.bids || []).map(b => m("li", null, m("strong", null, b.username), m("span", null, money(b.amount_cents)), m("small", null, b.created_at))))) : null) : null);
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/PortalPages', { PremiumPage: PremiumPage,PenaltiesPage: PenaltiesPage,VehiclesPage: VehiclesPage,VehiclePage: VehiclePage, });